import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; // ✅ required for ngModel
import { ChildListComponent } from './child-list/child-list.component';

@NgModule({
  declarations: [
    ChildListComponent,
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    ChildListComponent
  ]
})
export class ComponentOfListsModule { }
